<app-sidebar (nameMenu)="emitTitle($event)"></app-sidebar>
<app-header [nameHeader]="recibeTitle"></app-header>
<div class="bg-image">
  <div class="main-content">
    <router-outlet></router-outlet>
    <div class="container-fluid p-0">
      <app-footer></app-footer>
    </div>
  </div>
</div>
